
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"90","height":"88","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M87.117 55.538c-.293.29-.614.579-.964.868-1.83 1.6-3.922 2.372-6.277 2.314l-7.59-.059 7.59.059c2.355.058 4.447-.713 6.277-2.314.35-.29.671-.579.963-.868L74.154 75.902c-.33.5-.817 1.002-1.46 1.504-1.303 1.002-2.725 1.494-4.262 1.475l-10.919-.144-.146 8.388L46.653 68.67l10.773-19.756-.233 9.632 15.093.115-11.794-20.334L79.41 27.51l9.605 16.632c.37.79.632 1.601.788 2.43.525 2.7 0 5.178-1.577 7.434a7.805 7.805 0 01-1.021 1.417.445.445 0 00-.088.116zM26.245 3.385c2.063-1.832 4.477-2.661 7.24-2.487l1.693.289 24.495.26 2.072.463c1.538.578 2.686 1.523 3.445 2.835l5.547 9.343 7.328-4.223-10.394 18.628-22.655 1.099 8.467-4.773-7.65-12.872-11.531 20.566-19.152-10.442 9.401-16.777a11.289 11.289 0 011.694-1.909zm-8.67 54.525h23.617l.03 21.665H22.889c-1.07.058-2.258-.144-3.562-.607-2.589-.887-4.477-2.565-5.664-5.033a8.012 8.012 0 01-.7-1.591 12.684 12.684 0 01-.351-1.36c-.467-2.352-.098-4.522 1.11-6.508l3.853-6.566-3.854 6.567c-1.207 1.986-1.576 4.155-1.109 6.508.098.482.214.935.35 1.36L1.46 50.91c-.273-.54-.467-1.206-.584-1.996-.234-1.601.048-3.056.846-4.368L7.3 35.233 0 30.923h21.516l11.912 19.09-8.32-5.003-7.533 12.9zM35.178 1.187l1.402.231c2.277.752 4 2.14 5.167 4.165l4.087 6.364-4.087-6.363c-1.168-2.025-2.89-3.414-5.167-4.166l-1.402-.231z","fill":"#fff"}})])
          )
        }
      }
    